export default __webpack_public_path__ + "static/palash-150x135-7aa0af589683e2ef427c5d7412cb52c7.png";